import { render } from "./PlanetPage.vue?vue&type=template&id=7939ea82&scoped=true"
import script from "./PlanetPage.vue?vue&type=script&lang=js"
export * from "./PlanetPage.vue?vue&type=script&lang=js"

import "./PlanetPage.vue?vue&type=style&index=0&id=7939ea82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7939ea82"]])

export default __exports__